import { Injectable, signal } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface ModuleState {
  user_modules_id: Number;
  calendarType: string;
  label: string;
  description: string;
  selectedLabels?: string;
}

export interface SelectedDocument {
  document_name: string;
  user_modules_id: string | number;
  document_period: string;
  user_document_id: string | number;
}

@Injectable({
  providedIn: 'root'
})
export class DocumentStateServiceService {

  constructor() { }

  selectedModule = signal<ModuleState | null>(null);
  selectedChildLabel = signal<string>('');
  selectedDocument = signal<SelectedDocument | null>(null);
  showWelcome = signal<boolean>(false);
  private _sidebarRefresh$ = new BehaviorSubject<number>(0);
  sidebarRefresh$ = this._sidebarRefresh$.asObservable();

  // share logged-in user_type (Employee / Admin / Company / Support) 
  // Initialized straight from localStorage so a page refresh doesn't lose it
  // (login.component sets both the signal and localStorage on login).
  userType = signal<string>(localStorage.getItem('user_type') || '');

  setUserType(type: string): void {
    this.userType.set(type);
  }

  getUserType(): string {
    return this.userType();
  }

  private _currentTheme = signal<string>('light');
  private _currentColor = signal<string>('indigo');
  currentTheme = this._currentTheme.asReadonly();
  currentColor = this._currentColor.asReadonly();

  applyUserAppearance(user: { dark_mode?: string; messenger_color?: string } | null | undefined): void {
    if (!user) return;

    const theme = user.dark_mode === '1' ? 'dark' : 'light';
    const color = user.messenger_color || 'indigo';

    this._currentTheme.set(theme);
    this._currentColor.set(color);

    if (theme === 'dark') {
      document.documentElement.setAttribute('data-theme', 'dark');
    } else {
      document.documentElement.removeAttribute('data-theme');
    }

    if (color && color !== 'indigo') {
      document.documentElement.setAttribute('data-color', color);
    } else {
      document.documentElement.removeAttribute('data-color');
    }
  }

  setModule(data: ModuleState): void {
    this.selectedModule.set(data);
  }

  setSelectedChildLabel(label: string): void {
    this.selectedChildLabel.set(label);
  }

  setSelectedDocument(doc: SelectedDocument | null): void {
    this.selectedDocument.set(doc);
  }
  setShowWelcome(status: boolean): void {
    this.showWelcome.set(status);
  }
  getShowWelcome(): boolean {
    return this.showWelcome();
  }
  getSelectedDocument(): SelectedDocument | null {
    return this.selectedDocument();
  }

  triggerSidebarRefresh(): void {
    this._sidebarRefresh$.next(this._sidebarRefresh$.getValue() + 1);
  }

  clear(): void {
    this.selectedModule.set(null);
    this.selectedDocument.set(null);
    this.userType.set('');
  }
}